import { Outlet } from '@tanstack/react-router';

import ThreadList from '@/routes/(app)/(threads)/components/thread-list';

const Threads = () => (
  <div className='grid w-full grid-cols-[1fr_4fr] gap-4'>
    <ThreadList />
    <Outlet />
  </div>
);

export default Threads;
